import React, { useState } from "react";
import { Helmet } from "react-helmet";

import CoursesData from "../content.json";
// import { BsLightningFill } from "react-icons/gi";
import { BsLightningFill } from "react-icons/bs";
import Courses from "../Components/Courses";

function BABEd() {
  const [BCAData] = useState(CoursesData.Courses[0]);
  return (
		<>
			<Helmet>
				<title>Integrated B.A./B.Sc-B.Ed | University of Education</title>
			</Helmet>
			<div className="PageContainer">
				<div className="">
					{/* <div className="CourseBanner HeaderImg">
						<img src={BCAData.course_banner} alt="BCA-banner" />
					</div> */}

					<div id="Heading" className="CourseTitle" data-aos="fade-up">
						<h1>{BCAData.course_fullname}</h1>
					</div>
					<br />
					<p className="CourseDesc" data-aos="fade-up">
						{BCAData.course_desc}
					</p>
					<br />

					<div className="CourseDetailsContainer">
						<div id="Secondary_Heading" data-aos="fade-up">
							<h3>Course Detail</h3>
						</div>
						<div className="CourseTable" data-aos="fade-up">
							<table>
								<tr data-aos="fade-up">
									<td>Course -</td>
									<td>{BCAData.course_fullname}</td>
								</tr>
								<tr data-aos="fade-up">
									<td>Recognizing body -</td>
									<td>{BCAData.course_certification}</td>
								</tr>
								{/* <tr data-aos="fade-up">
                  <td>Shift -</td>
                  <td>{BCAData.course_shift}</td>
                </tr> */}
								<tr data-aos="fade-up">
									<td>Duration -</td>
									<td>{BCAData.course_duration}</td>
								</tr>
								<tr data-aos="fade-up">
									<td>No. of Semester -</td>
									<td>{BCAData.course_sem}</td>
								</tr>
								<tr data-aos="fade-up">
									<td>Seats -</td>
									<td>{BCAData.course_seat}</td>
								</tr>
								<tr data-aos="fade-up">
									<td>Eligibility -</td>
									<td>{BCAData.course_eligibility}</td>
								</tr>
								<tr data-aos="fade-up">
									<td>Fees -</td>
									<td>{BCAData.course_fee_per_sem}</td>
								</tr>
								<tr data-aos="fade-up">
									<td>Affiliation -</td>
									<td>{BCAData.university}</td>
								</tr>
							</table>
						</div>
					</div>

						{/* 3. ELIGIBILITY FOR ADMISSION AND PATTERN OF SELECTION */}
						<div className="Section" style={{ marginBottom: "30px" }} data-aos="fade-up">
							<div className="SubHeading">
								<h4>3. ELIGIBILITY FOR ADMISSION AND PATTERN OF SELECTION</h4>
							</div>
							<ul>
								<li style={{ display: "flex", gap: "10px", alignItems: "flex-start", lineHeight: "1.6", marginBottom: "10px" }}>
									<div style={{ minWidth: "15px", marginTop: "5px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										(a) Candidates with at least 50% in the senior secondary/ +2 or its equivalent are eligible for admission.
									</div>
								</li>
								<li style={{ display: "flex", gap: "10px", alignItems: "flex-start", lineHeight: "1.6", marginBottom: "10px" }}>
									<div style={{ minWidth: "15px", marginTop: "5px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										(b) The reservation and relaxation in marks for SC/ST/OBC/PWD and other category shall be as per the rules of Jharkhand Govt./V.B.U. University.
									</div>
								</li>
								<li style={{ display: "flex", gap: "10px", alignItems: "flex-start", lineHeight: "1.6", marginBottom: "10px" }}>
									<div style={{ minWidth: "15px", marginTop: "5px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										(c) The selection of candidates for admission to 4 years integrated B.A. B.Ed/ B.Sc. B.Ed. course shall be made on the basis of marks obtained in matric, intermediate course and NCC B/C certificate/sports certificate (state/nation).
									</div>
								</li>
								<li style={{ display: "flex", gap: "10px", alignItems: "flex-start", lineHeight: "1.6", marginBottom: "10px" }}>
									<div style={{ minWidth: "15px", marginTop: "5px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										(d) The admission should be made strictly in order of merit.
									</div>
								</li>
							</ul>
						</div>

						{/* HOW TO APPLY */}
						<div className="Section" style={{ marginBottom: "30px" }} data-aos="fade-up">
							<div className="SubHeading">
								<h4>HOW TO APPLY</h4>
							</div>
							<p>
								Application form can be obtained from the University Department
								of Education, Kautilya Bhavan, Vinoba Bhave University Campus,
								Hazaribag. It is to be duly filled in by the candidate and
								submitted to the above office along with all relevant documents
								such as :-
							</p>
							<ul>
								<li style={{ display: "flex", gap: "10px", alignItems: "flex-start", lineHeight: "1.6", marginBottom: "10px" }}>
									<div style={{ minWidth: "15px", marginTop: "5px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										Attested Photocopy of the Matriculation/ICSE/CBSE pass certificate (Date of Birth proof).
									</div>
								</li>
								<li style={{ display: "flex", gap: "10px", alignItems: "flex-start", lineHeight: "1.6", marginBottom: "10px" }}>
									<div style={{ minWidth: "15px", marginTop: "5px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										Attested Photocopy of mark sheet of I.A./I.Sc./I.Com. examination.
									</div>
								</li>
								<li style={{ display: "flex", gap: "10px", alignItems: "flex-start", lineHeight: "1.6", marginBottom: "10px" }}>
									<div style={{ minWidth: "15px", marginTop: "5px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										Recent Colour stamp/passport size photograph.
									</div>
								</li>
								<li style={{ display: "flex", gap: "10px", alignItems: "flex-start", lineHeight: "1.6", marginBottom: "10px" }}>
									<div style={{ minWidth: "15px", marginTop: "5px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										Attested Photocopy of caste certificate issued by the authority not below the rank of SDO.
									</div>
								</li>
								<li style={{ display: "flex", gap: "10px", alignItems: "flex-start", lineHeight: "1.6", marginBottom: "10px" }}>
									<div style={{ minWidth: "15px", marginTop: "5px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										NCC Certificate (if applicable).
									</div>
								</li>
								<li style={{ display: "flex", gap: "10px", alignItems: "flex-start", lineHeight: "1.6", marginBottom: "10px" }}>
									<div style={{ minWidth: "15px", marginTop: "5px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										One self-addressed envelope with stamp of forty two (42) rupees.
									</div>
								</li>
							</ul>
							<br />
							<p>
								Application forms should be submitted to the office of the
								Department. Incomplete and late application form or furnishing
								false information will be summarily rejected without any
								information to the concerned candidate. In this connection no
								correspondence will be entertained.
							</p>
						</div>

						{/* SELECTION OF CANDIDATES FOR ADMISSION */}
						<div className="Section" style={{ marginBottom: "30px" }} data-aos="fade-up">
							<div className="SubHeading">
								<h4 style={{ color: "#d32f2f" }}>
									SELECTION OF CANDIDATES FOR ADMISSION
								</h4>
							</div>
							<p>
								The selection of candidates for admission to 4 years integrated
								B.A./ B.Sc.- B.Ed. course will be done strictly in accordance with
								the merit list prepared on the basis of rules and regulations laid
								down by the Govt. of Jharkhand and Vinoba Bhave University,
								Hazaribag. List of the selected candidates will be displayed on the
								office notice board, and the candidate selected for admission will
								be informed by registered post. They will be required to get
								admitted within the stipulated time, failing which the seat will be
								offered to the next candidate in the waiting list.
							</p>
						</div>

						{/* SELECTION PROCEDURE */}
						<div className="Section" style={{ marginBottom: "30px" }} data-aos="fade-up">
							<div className="SubHeading">
								<h4 style={{ color: "#d32f2f" }}>SELECTION PROCEDURE</h4>
							</div>
							<p>
								Admission to the above course shall be on the basis of career points
								obtained by the applicant and allotted and calculated as per
								university norms which is as follows:
							</p>
							<div className="CourseTable">
								<table>
									<thead>
										<tr>
											<th>Optional marks undersigned/ reserved category</th>
											<th>Matric</th>
											<th>Higher Secondary/ + 2</th>
											<th>Reserved Category Certificates</th>
											<th>Points</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td>Above 50%/45% and less than 60%</td>
											<td>05</td>
											<td>05</td>
											<td>NCC (B Certificate)</td>
											<td>02</td>
										</tr>
										<tr>
											<td>Upto 60% - 65%</td>
											<td>06</td>
											<td>06</td>
											<td>NCC (C Certificate)</td>
											<td>03</td>
										</tr>
										<tr>
											<td>Upto 65% - 70%</td>
											<td>07</td>
											<td>07</td>
											<td>Sports Certificate (State)</td>
											<td>03</td>
										</tr>
										<tr>
											<td>Upto 70% - 75%</td>
											<td>08</td>
											<td>08</td>
											<td>Sports Certificate (National)</td>
											<td>05</td>
										</tr>
										<tr>
											<td>Upto 75% - 80%</td>
											<td>09</td>
											<td>09</td>
											<td>Sports Certificate (National)</td>
											<td>05</td>
										</tr>
										<tr>
											<td>Upto 80%</td>
											<td>10</td>
											<td>10</td>
											<td></td>
											<td></td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>

						{/* ADMISSION : */}
						<div className="Section" style={{ marginBottom: "30px" }} data-aos="fade-up">
							<div className="SubHeading">
								<h4 style={{ color: "#d32f2f" }}>ADMISSION :</h4>
							</div>
							<p>
								The following original certificates must be produced by the
								candidates at the time of admission/ counseling :-
							</p>
							<ul>
								<li style={{ display: "flex", gap: "10px", alignItems: "flex-start", lineHeight: "1.6", marginBottom: "10px" }}>
									<div style={{ minWidth: "15px", marginTop: "5px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										School/College leaving certificate.
									</div>
								</li>
								<li style={{ display: "flex", gap: "10px", alignItems: "flex-start", lineHeight: "1.6", marginBottom: "10px" }}>
									<div style={{ minWidth: "15px", marginTop: "5px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										In case the candidate has passed his/her last examination from a Board/University other than Vinoba Bhave University, Migration certificate of the Board/University from which the candidate received his/her Degree.
									</div>
								</li>
								<li style={{ display: "flex", gap: "10px", alignItems: "flex-start", lineHeight: "1.6", marginBottom: "10px" }}>
									<div style={{ minWidth: "15px", marginTop: "5px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										Caste Certificate (for SC/ST/BC/OBC only) issued by an authority not below the rank of SDO.
									</div>
								</li>
								<li style={{ display: "flex", gap: "10px", alignItems: "flex-start", lineHeight: "1.6", marginBottom: "10px" }}>
									<div style={{ minWidth: "15px", marginTop: "5px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										Three copies of recent stamp size photograph (same as pasted in the application form).
									</div>
								</li>
								<li style={{ display: "flex", gap: "10px", alignItems: "flex-start", lineHeight: "1.6", marginBottom: "10px" }}>
									<div style={{ minWidth: "15px", marginTop: "5px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										Mark sheet from matriculation upto the last acquired degree.
									</div>
								</li>
								<li style={{ display: "flex", gap: "10px", alignItems: "flex-start", lineHeight: "1.6", marginBottom: "10px" }}>
									<div style={{ minWidth: "15px", marginTop: "5px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										Matriculation Certificate.
									</div>
								</li>
								<li style={{ display: "flex", gap: "10px", alignItems: "flex-start", lineHeight: "1.6", marginBottom: "10px" }}>
									<div style={{ minWidth: "15px", marginTop: "5px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										NCC Certificate/Sports Certificate, if any.
									</div>
								</li>
								<li style={{ display: "flex", gap: "10px", alignItems: "flex-start", lineHeight: "1.6", marginBottom: "10px" }}>
									<div style={{ minWidth: "15px", marginTop: "5px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										Physically Challenged Certificate, if any.
									</div>
								</li>
							</ul>
						</div>

						{/* RULES */}
						<div className="Section" style={{ marginBottom: "30px" }} data-aos="fade-up">
							<div className="SubHeading">
								<h4
									style={{
										backgroundColor: "#d32f2f",
										color: "white",
										padding: "5px 10px",
										display: "inline-block",
									}}
								>
									RULES
								</h4>
							</div>
							<ul>
								<li style={{ display: "flex", gap: "10px", alignItems: "flex-start", lineHeight: "1.6", marginBottom: "10px" }}>
									<div style={{ minWidth: "15px", marginTop: "5px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										Students will strictly comply with the rules and regulations of the Institution issued from time to time relating to their studies, examination, conduct and discipline.
									</div>
								</li>
								<li style={{ display: "flex", gap: "10px", alignItems: "flex-start", lineHeight: "1.6", marginBottom: "10px" }}>
									<div style={{ minWidth: "15px", marginTop: "5px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										The students, who secure admission on the basis of false certificates, mark sheet or on the basis of any misrepresentation of facts or illegal means, shall be summarily cancelled and all fees paid by him/her shall be forfeited. Legal action shall also be taken against them.
									</div>
								</li>
								<li style={{ display: "flex", gap: "10px", alignItems: "flex-start", lineHeight: "1.6", marginBottom: "10px" }}>
									<div style={{ minWidth: "15px", marginTop: "5px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										Candidates are required to enclose along with their application an affidavit sworn before a Notary Public that all information given by them are true.
									</div>
								</li>
								<li style={{ display: "flex", gap: "10px", alignItems: "flex-start", lineHeight: "1.6", marginBottom: "10px" }}>
									<div style={{ minWidth: "15px", marginTop: "5px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										Applications not accompanied with requisite documents/enclosures or submitted after the last date shall be summarily rejected.
									</div>
								</li>
								<li style={{ display: "flex", gap: "10px", alignItems: "flex-start", lineHeight: "1.6", marginBottom: "10px" }}>
									<div style={{ minWidth: "15px", marginTop: "5px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										No refund of fees will be made on withdrawal of admission under any circumstances.
									</div>
								</li>
								<li style={{ display: "flex", gap: "10px", alignItems: "flex-start", lineHeight: "1.6", marginBottom: "10px" }}>
									<div style={{ minWidth: "15px", marginTop: "5px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										If the applicant is employed, employer's no objection certificate and four years leave must be submitted at the time of admission.
									</div>
								</li>
							</ul>
						</div>

						{/* RESERVATION */}
						<div className="Section" style={{ marginBottom: "30px" }} data-aos="fade-up">
							<div className="SubHeading">
								<h4 style={{ color: "#d32f2f" }}>RESERVATION :</h4>
							</div>
							<ul>
								<li>
									(a) As per Government of Jharkhand Rules declared from time to
									time and adopted by the University.
								</li>
								<li>
									(b) Seats left unfilled in any of the reserved category by
									reason of the fact that no eligible candidate is available in
									the respective category shall be filled up by admitting
									candidates available from other reserved categories keeping
									the hierarchy of reserved/unreserved into consideration.
								</li>
							</ul>
						</div>

						{/* RESERVATION OF SEATS */}
						<div className="Section" style={{ marginBottom: "30px" }} data-aos="fade-up">
							<div className="SubHeading">
								<h4
									style={{
										backgroundColor: "#d32f2f",
										color: "white",
										padding: "5px 10px",
										display: "inline-block",
									}}
								>
									RESERVATION OF SEATS
								</h4>
							</div>
							<div className="CourseTable">
								<table>
									<thead>
										<tr>
											<th>Category</th>
											<th>B.A. B.Ed. (50 Seats)</th>
											<th>B.Sc. B.Ed. (50 Seats)</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td>UR</td>
											<td>25</td>
											<td>25</td>
										</tr>
										<tr>
											<td>BC-1</td>
											<td>04</td>
											<td>04</td>
										</tr>
										<tr>
											<td>BC-2</td>
											<td>03</td>
											<td>03</td>
										</tr>
										<tr>
											<td>ST</td>
											<td>13</td>
											<td>13</td>
										</tr>
										<tr>
											<td>SC</td>
											<td>05</td>
											<td>05</td>
										</tr>
										<tr>
											<td>Divyang</td>
											<td colSpan="2">
												For physical challenged (Divyang) 03 Seats.
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>

						{/* FEE */}
						<div className="Section" style={{ marginBottom: "30px" }} data-aos="fade-up">
							<div className="SubHeading">
								<h4
									style={{
										backgroundColor: "#d32f2f",
										color: "white",
										padding: "5px 10px",
										display: "inline-block",
									}}
								>
									FEE
								</h4>
							</div>
							<p>1. Each semester</p>
							<ul>
								<li style={{ display: "flex", gap: "10px", alignItems: "center", lineHeight: "1.6", marginBottom: "10px" }}>
									<div style={{ minWidth: "15px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										<b>General</b> - Rs. 25,000.00 (Rupees Twenty Five Thousand Only)
									</div>
								</li>
								<li style={{ display: "flex", gap: "10px", alignItems: "center", lineHeight: "1.6", marginBottom: "10px" }}>
									<div style={{ minWidth: "15px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										<b>OBC</b> - Rs. 25,000.00 (Rupees Twenty Five Thousand Only)
									</div>
								</li>
								<li style={{ display: "flex", gap: "10px", alignItems: "center", lineHeight: "1.6", marginBottom: "10px" }}>
									<div style={{ minWidth: "15px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										<b>SC / ST</b> - Rs. 22,000.00 (Twenty Two Thousand Only)
									</div>
								</li>
							</ul>
							<br />
							<p>
								All fees will be accepted in the form of DD in favour of 'The
								Registrar, Vinoba Bhave University, Hazaribag' payable at
								Hazaribag.
							</p>
							<br />
							<p style={{fontStyle: 'italic', fontSize: '0.9em'}}>
								* Prospectus and Application Form may be obtained from the
								Department of Education personally on all working days on
								payment of Rs. 500/- (for Gen/OBC) and Rs. 400/- (for SC/ST)
								in Cash/Draft. This may also be obtained by post on payment of
								Rs. 550/- (for Gen/OBC) and Rs.450/- (for SC/ST).
							</p>
						</div>



					<section>
						<Courses />
					</section>
				</div>
			</div>
		</>
	);
}

export default BABEd;
